import { render } from "./CustomCssSettings.vue?vue&type=template&id=5fec2a66"
import script from "./CustomCssSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CustomCssSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./CustomCssSettings.vue?vue&type=style&index=0&id=5fec2a66&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__